<div class="questionContainer">
    <div class="titleContainer">
        <div class="title">{{ question.question_content }}</div>
    </div>
    <div class="contentContainer">
        <div class="questionContainerBig">
            <div
                (click)="validateQuestion(true)"
                class="goBlock"
                [class.correct]="goButtonState === 'correct'"
                [class.incorrect]="goButtonState === 'incorrect'"
            >
                <div class="goText">GO</div>
            </div>
            <div class="proposition">
                @if (showProposition) {
                <div class="propText">{{ question.answers[index] }}</div>
                }
            </div>
            <div
                (click)="validateQuestion(false)"
                class="noGoBlock"
                [class.correct]="noGoButtonState === 'correct'"
                [class.incorrect]="noGoButtonState === 'incorrect'"
            >
                <div class="noGoText">NO GO</div>
            </div>
        </div>
        <div class="questionContainerSmall">
            <div class="proposition">
                @if (showProposition) {
                <div class="propText">{{ question.answers[index] }}</div>
                }
            </div>
            <div class="answersContainer">
                <div
                    (click)="validateQuestion(true)"
                    class="goBlock"
                    [class.correct]="goButtonState === 'correct'"
                    [class.incorrect]="goButtonState === 'incorrect'"
                >
                    <div class="goText">GO</div>
                </div>
                <div
                    (click)="validateQuestion(false)"
                    class="noGoBlock"
                    [class.correct]="noGoButtonState === 'correct'"
                    [class.incorrect]="noGoButtonState === 'incorrect'"
                >
                    <div class="noGoText">NO GO</div>
                </div>
            </div>
        </div>
    </div>
</div>
